import ConfigService from './configService'
import { get, has } from 'lodash-es'

const ConfigPlugin = {
  install: function (Vue, options) {
    if (has(options, 'clientConfigurationBundle')) {
      ConfigService.replaceLoadedBundle('client', get(options, 'clientConfigurationBundle'))
    }
    /**
     * Instance registration
     * @type {{get: (function(*=, *=): *)}}
     */
    Vue.prototype.$conf = ConfigService
    /**
     * Global method registration
     * @type {{get: (function(*=, *=): *)}}
     */
    Vue.conf = ConfigService
    /**
     * Config mixin
     */
    Vue.mixin({
      data: () => {
        return {
          conf: ConfigService
        }
      }
    })
  }
}

export default ConfigPlugin
